export default __webpack_public_path__ + "static/media/select_leader.51d8a73e.png";